<template>
  <div>
    <el-container
      class="h-screen border-card"
      :style="{
        backgroundColor: !removeTopAndSidebar
          ? '#ccc !important'
          : '#fff !important',
      }"
    >
      <expired v-if="showExpired"></expired>
      <el-drawer
        :visible.sync="drawer"
        :with-header="false"
        direction="ltr"
        :size="200"
      >
        <span>
          <el-menu id="custom-aside-menu" class="bg-black bg-opacity-80">
            <el-menu-item
              index="0"
              style="height: 4rem !important; background-color: #fff !important"
              id="first-menu-item"
            >
              <div class="flex justify-center items-center h-full w-full">
                <img
                  src="@/assets/logo.svg"
                  class="h-12 object-contain w-full"
                />
              </div>
            </el-menu-item>

            <el-menu-item
              :index="menuItem.index"
              v-for="(menuItem, index) in filteredMenu"
              :key="index"
              @click="changeMenu(menuItem)"
              :class="{
                'bg-primary rounded-md': selectedMenu == menuItem.name,
              }"
              class="flex flex-row text-white items-center gap-3 pl-2 py-0 cursor-pointer hover:bg-primary rounded-md my-1 transition ease-in-out delay-75"
            >
              <img :src="menuItem.icon" class="h-4" />
              {{ menuItem.name }}
            </el-menu-item>
          </el-menu>
        </span>
      </el-drawer>
      <el-aside
        width="200px"
        class="bg-black bg-opacity-80 hidden lg:block h-screen"
        v-if="!removeTopAndSidebar"
      >
        <el-menu id="custom-aside-menu" class="bg-black bg-opacity-80 h-full">
          <el-menu-item
            index="0"
            style="height: 4rem !important; background-color: #fff !important"
            id="first-menu-item"
          >
            <div class="flex justify-center items-center h-full w-full">
              <img src="@/assets/logo.svg" class="h-12 object-contain w-full" />
            </div>
          </el-menu-item>

          <el-menu-item
            :index="menuItem.index"
            v-for="(menuItem, index) in filteredMenu"
            :key="index"
            @click="changeMenu(menuItem)"
            :class="{
              'bg-primary rounded-md': selectedMenu == menuItem.name,
            }"
            class="flex flex-row text-white items-center gap-3 pl-2 py-0 cursor-pointer hover:bg-primary rounded-md my-1 transition ease-in-out delay-75"
          >
            <img :src="menuItem.icon" class="h-4" />
            {{ menuItem.name }}
          </el-menu-item>
        </el-menu>
      </el-aside>

      <el-container id="main-container" class="border-card">
        <el-header
          style="
            text-align: right;
            font-size: 12px;
            height: 4rem;
            padding-top: 0.25rem;
          "
          class="my-auto flex bg-white shadow justify-between items-center sticky top-0 z-50"
          v-if="!removeTopAndSidebar"
        >
          <div
            @click="drawer = true"
            class="lg:hidden ml-5 flex h-full items-center gap-2"
          >
            <img
              src="@/assets/icons/menu.png"
              class="h-5 object-contain cursor-pointer"
            />
            <img src="@/assets/logo.svg" class="h-12 object-contain" />
          </div>
          <div class="flex ml-auto items-center gap-5">
            <div>
              <img
                @click="showSearch = true"
                class="h-5 w-5 cursor-pointer object-contain inline mr-5"
                src="@/assets/icons/search.png"
              />

              <el-popover
                placement="bottom"
                title="Notifications"
                width="300"
                trigger="hover"
                content=""
              >
                <el-button
                  slot="reference"
                  type="text"
                  style="padding: 0 !important"
                >
                  <div class="bg-primary rounded-full p-1 relative">
                    <img
                      class="h-6 w-6 p-0.5 object-contain inline"
                      src="@/assets/icons/bell.png"
                      @click="goToNotifications"
                    />
                    <span
                      class="absolute top-0 bg-blue-500 text-white rounded-full text-xs right-0 px-1"
                      >{{ ureadNotifications.length }}</span
                    >
                  </div>
                </el-button>
                <main class="h-96 overflow-y-scroll">
                  <section
                    v-for="notification in notifications"
                    :key="notification.id"
                    class="border-b-0.5 mb-3 cursor-pointer hover:bg-gray-300 p-2"
                    @click="goToNotifications(notification)"
                  >
                    <section class="flex gap-3">
                      <h1>{{ notification.title }}</h1>
                      <small class="text-primary font-semibold">{{
                        convertToSentenceCase(notification.type)
                      }}</small>
                    </section>
                    <section>
                      <p>From: {{ notification.createdBy }}</p>
                    </section>
                    <section class="my-2 text-gray-400">
                      <p>{{ getTimePosted(notification.createdAt) }}</p>
                    </section>
                  </section>
                </main>
                <section class="text-center">
                  <button
                    class="font-bold text-center"
                    @click="goToNotifications"
                  >
                    View All
                  </button>
                </section>
              </el-popover>
            </div>
            <div class="h-8 w-8 rounded-full flex cursor-pointer">
              <VMenu :placements="bottom" :skidding="-30">
                <div class="flex items-center gap-1 h-8 w-8 rounded-full">
                  <img
                    class="h-full w-full rounded-full"
                    src="@/assets/icons/user.png"
                    alt="avatar"
                  />
                </div>

                <template #popper>
                  <div class="flex flex-col bg-gray-100">
                    <p
                      @click="changePassword()"
                      class="cursor-pointer hover:bg-primary hover:text-white p-2"
                    >
                      Change Password
                    </p>
                    <p
                      @click="logOut()"
                      class="cursor-pointer hover:bg-primary hover:text-white p-2"
                    >
                      Log Out
                    </p>
                  </div>
                </template>
              </VMenu>
            </div>
          </div>
        </el-header>

        <el-main class="border-card">
          <router-view></router-view>
        </el-main>
      </el-container>
    </el-container>
    <Search :showSearch="showSearch" @close="showSearch = false"></Search>
  </div>
</template>

<style>
.el-header {
  background-color: #fff;

  line-height: 60px;
}

.el-aside {
  background-color: #6b6b6b !important;
}
</style>

<script>
import { mapGetters } from "vuex";
import decryptData from "./utils/decrypt";
import { viewSecuredAttachment } from "./utils/secureAttachmentsViewer";
import Expired from "@/components/auth/expired.vue";
export default {
  data() {
    return {
      drawer: false,
      imageURL: null,
      user: null,
      role: null,
      selectedMenu: "",
      currentUserType: "",
      decryptDataLocal: "",
      decryptionKey: "",

      bottom: "bottom",
      showSearch: false,

      profilePictureUrl: null,
      loading: false,
      ureadNotifications: 0,
      // notifications: notifications,

      info: {
        Logo: "https://www.clker.com/cliparts/b/l/0/w/q/3/modified-generic-company-logo.svg",
      },

      menus: [
        {
          name: "Requests",
          route: "requests",
          icon: require("@/assets/icons/user-add.png"),
          visibility: ["Admin"],
          about:
            "View, review, approve or decline organizations enrollment request",
        },
        {
          name: "Organizations",
          route: "organizations",
          icon: require("@/assets/icons/buildings.png"),
          visibility: ["Admin"],
          about: "View and action on organizations enrolled",
        },
        {
          name: "Setups",
          route: "setups",
          icon: require("@/assets/icons/settings.png"),
          visibility: ["Admin"],
          about: "Perform setup required that affect the whole TalantHR",
          keywords: [
            "Email Templates",
            "SMS Templates",
            "Email Gateway",
            "SMS Gateway",
            "Pricing",
            "Licensing",
            "Trial",
          ],
        },
        {
          name: "Licenses",
          route: "licenses",
          icon: require("@/assets/icons/license.svg"),
          visibility: ["Admin"],
          about: "View licences, both active and inactive.",
        },

        {
          name: "Users",
          route: "users",
          icon: require("@/assets/icons/users.png"),
          visibility: ["Admin"],
          about: "Get a list of all users",
        },
      ],
    };
  },
  components: {
    Search: () => import("@/components/search/search.vue"),
    Expired,
  },

  computed: {
    ...mapGetters([
      "getRouteTo",
      "getUser",
      "getProfileCompletion",
      "getOrganization",
      "getUserType",
      "getToken",
    ]),
    filteredMenu() {
      var menus = [];
      const userRoleWithSpaces = this.getUserType;

      this.menus.forEach((menu) => {
        if (menu.visibility.includes(userRoleWithSpaces)) {
          menus.push(menu);
        }
      });

      return menus;
    },

    removeTopAndSidebar() {
      var show;
      if (this.getRouteTo == "login") {
        show = true;
      } else if (this.getRouteTo == "changePassword") {
        show = true;
      } else if (this.getRouteTo == null) {
        show = true;
      } else if (this.getRouteTo == undefined) {
        show = true;
      } else if (this.getRouteTo == "NotFound") {
        show = true;
      } else if (this.getRouteTo == "OrgNotFound") {
        show = true;
      } else {
        show = false;
      }

      return show;
    },

    showExpired() {
      var show;
      if (this.$route.name == "login") {
        show = false;
      } else if (this.$route.name == "NotFound") {
        show = false;
      } else if (this.$route.name == null) {
        show = false;
      } else if (this.$route.name == undefined) {
        show = false;
      } else {
        show = true;
      }
      return show;
    },
  },
  watch: {
    $route(to) {
      this.menus.forEach((menu) => {
        // alert(to.name);
        if (menu.route == to.name) {
          this.selectedMenu = menu.name;
        }
      });
      // remove selected menu on profile page
      if (to.name == "profile") {
        this.selectedMenu = null;
      }
    },

    profilePicture: {
      handler: function () {
        this.viewProfilePicture();
      },
      immediate: true,
    },

    "info.Logo": {
      handler: function (newLogo) {
        this.info.Logo = newLogo;
        this.$forceUpdate();
      },
      immediate: true,
    },
  },
  created() {
    this.currentUserType = this.getUserType.toLowerCase();
    this.getOrganizationInfo();
    this.decryptDataLocal = decryptData;
    this.decryptionKey = this.$decryptionKey;
    this.$store.commit("storeSidebarMenus", this.menus);
    this.menus.forEach((menu) => {
      if (menu.route == this.$route.name) {
        this.selectedMenu = menu.name;
      }
    });
  },
  methods: {
    async viewProfilePicture() {
      try {
        const imageUrl = await viewSecuredAttachment(
          this.getUser.ProfilePicture,
          this.getToken
        );

        this.profilePictureUrl = imageUrl;
      } catch (error) {
        return "";
        // console.error("Error fetching profile picture:", error);
      }
    },

    changeMenu(menu) {
      // alert(menu.name);
      this.selectedMenu = menu.name;
      // close side menu on mobile
      if (this.drawer) {
        this.drawer = false;
      }
      this.close();
      switch (menu.name) {
        case "Requests":
          this.$router.push({
            name: "requests",
            params: {},
          });
          break;

        case "Organizations":
          this.$router.push({
            name: menu.route,
            params: {},
          });
          break;
        case "Setups":
          this.$router.push({
            name: menu.route,
            params: { type: "emails" },
          });
          break;
        case "Licenses":
          this.$router.push({
            name: menu.route,
            params: { type: "all" },
          });
          break;

        case "Users":
          this.$router.push({
            name: menu.route,
            params: {},
          });
          break;

        case "Notifications":
          this.$router.push({
            name: menu.route,
            params: {},
          });
          break;
        default:
          break;
      }
    },
    close() {
      this.$emit("closeSideMenu");
    },

    logOut() {
      // this.$store.commit("logout");
      this.$router.replace({
        name: "login",
        params: {},
      });
      this.$store.commit("logout");
      window.sessionStorage.removeItem("app-data-hrs");
    },
    changePassword() {
      this.$router.replace({
        name: "changePassword",
        params: {},
      });
    },
    goToNotifications(notification) {
      this.$router.push({
        name: "notifications",
        params: {
          notification: "id" in notification ? notification : null,
          company: this.getOrganization,
        },
      });
    },

    openMenu() {
      this.$emit("openMenu");
    },
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Montserrat&display=swap");

* {
  font-family: "Montserrat", sans-serif;
}

/* Modal transition */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active in <2.1.8 */ {
  opacity: 0;
}

/* Center everything */
.center-h-v {
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}

/* Accordion transition */
.accordion-enter-active,
.accordion-leave-active {
  will-change: height, opacity;
  transition: height 0.3s ease, opacity 0.3s ease;
  overflow: hidden;
}

.accordion-enter,
.accordion-leave-to {
  height: 0 !important;
  opacity: 0;
}

/* Radio button */
.b-contain *,
.b-contain *::before,
.b-contain *::after {
  box-sizing: content-box !important;
}

.b-contain input {
  position: absolute;
  z-index: -1;
  opacity: 0;
}

.b-contain span {
  line-height: 1.54;
  font-size: 1rem;
  font-family: inherit;
}

.b-contain {
  display: table;
  position: relative;
  padding-left: 1.8rem;
  cursor: pointer;
  /* margin-bottom: 0.5rem; */
}

.b-contain input[type="radio"] ~ .b-input {
  position: absolute;
  top: 0;
  left: 0;
  height: 1.25rem;
  width: 1.25rem;
  background: rgba(241, 245, 248, 1);
  transition: background 250ms;
  border: 1px solid rgba(184, 194, 204, 1);
  border-radius: 2rem;
}

.b-contain input[type="radio"] ~ .b-input::after {
  content: "";
  position: absolute;
  display: none;
  left: 0.25rem;
  top: 0.25rem;
  width: 0.75rem;
  height: 0.75rem;
  border-radius: 2rem;
  background: rgba(255, 255, 255, 1);
  transition: background 250ms;
}

.b-contain input:checked ~ .b-input::after {
  display: block;
}

.b-contain:hover input ~ .b-input,
.b-contain input:focus ~ .b-input {
  background: rgb(231, 238, 243);
}

.b-contain input:focus ~ .b-input {
  box-shadow: 0 0 0 2px #dea42c;
}

.b-contain input:checked ~ .b-input {
  background: #dea42c;
  border-color: #dea42c;
}

.b-contain .b-input::before {
  content: "";
  display: block;
  position: absolute;
  left: 0;
  top: 0;
  width: 3rem;
  height: 3rem;
  margin-left: -0.85rem;
  margin-top: -0.85rem;
  background: #dea42c;
  border-radius: 2rem;
  opacity: 0.6;
  z-index: 99999;
  transform: scale(0);
}

input,
select,
button {
  border-radius: 0.375rem !important;
  padding-left: 0.75rem !important;
  padding-right: 0.75rem !important;
  height: 32px !important;
}
input[type="checkbox"] {
  height: auto !important;
}

.ve-table-header-th {
  font-weight: bold !important;
  background-color: #e6e4e4 !important;
  font-size: 0.8rem !important;
}
.ve-table-body-td {
  font-size: 0.8rem !important;
}

.el-input__inner,
.el-input__inner:focus {
  --tw-bg-opacity: 1;
  background-color: rgba(229, 231, 235, var(--tw-bg-opacity)) !important;
  padding: 0.5rem !important;
  height: 36.5px !important;
}

.vdp-datepicker * {
  box-sizing: border-box;
  background-color: transparent;
  outline: none;
  width: 100%;
  cursor: pointer;
}

:focus-visible {
  outline: none;
}

@keyframes b-ripple {
  0% {
    transform: scale(0);
  }

  20% {
    transform: scale(1);
  }

  100% {
    opacity: 0;
    transform: scale(1);
  }
}

@keyframes b-ripple-duplicate {
  0% {
    transform: scale(0);
  }

  30% {
    transform: scale(1);
  }

  60% {
    transform: scale(1);
  }

  100% {
    opacity: 0;
    transform: scale(1);
  }
}

.b-contain input + .b-input::before {
  animation: b-ripple 250ms ease-out;
}

.b-contain input:checked + .b-input::before {
  animation-name: b-ripple-duplicate;
}

.b-contain .b-input::before {
  visibility: hidden;
}

.b-contain input:focus + .b-input::before {
  visibility: visible;
}

.b-contain:first-child .b-input::before {
  visibility: hidden;
}

.v-popper--theme-menu .v-popper__inner:hover,
:focus {
  border: none;
  background-color: white;
  resize: none;
  outline: 0;
}

.ve-table .ve-table-cell {
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
}

*,
body {
  font-size: 0.8rem !important;
}

.ve-table
  .ve-table-container
  .ve-table-content-wrapper
  table.ve-table-content
  tbody.ve-table-body
  tr.ve-table-body-tr
  td.ve-table-body-td,
.ve-table
  .ve-table-container
  .ve-table-content-wrapper
  table.ve-table-content
  tbody.ve-table-body
  tr.ve-table-expand-tr
  td.ve-table-body-td {
  padding: 0 4px !important;
  font-size: 0.8rem !important;
}

.ve-table
  .ve-table-container
  .ve-table-content-wrapper
  table.ve-table-content
  thead.ve-table-header
  tr.ve-table-header-tr
  th.ve-table-header-th {
  background-color: #fafafa;
  padding: 0 4px !important;
}
.tox-statusbar__branding {
  display: none !important;
}

.el-dialog__body {
  padding: 0 !important;
}

button#download {
  display: none !important;
  height: 0 !important;
  width: 0 !important;
  visibility: hidden !important;
}

#secondaryDownload {
  display: none !important;
}

#toolbarViewerRight {
  display: none !important;
}
.toolbar {
  display: none !important;
}
div#outerContainer
  div#mainContainer
  div.toolbar
  div#toolbarContainer
  div#toolbarViewer {
  display: none !important;
}

.vdp-datepicker {
  padding: 0 !important;
}
.el-submenu__title {
  background-color: #6b6b6b !important;
}
.el-card__body,
.el-main {
  padding: 0 !important;
  margin: 0 !important;
}

.el-menu-item {
  height: 2rem !important;
  color: #fff !important;
  width: 13rem;
  /* margin: 0 auto; */
  border-radius: 10rem;
  /* margin: 0.5rem; */
}

.el-menu-item:hover {
  --tw-bg-opacity: 1;
  background-color: rgba(222, 164, 44, var(--tw-bg-opacity)) !important;
  color: #fff;
}

#first-menu-item.el-menu-item {
  background-color: #fff !important;
  position: sticky;
  top: 0;
  z-index: 1;
  border-radius: 0 !important;
  width: 100%;
  margin: 0 auto;
}

#second-menu-item.el-menu-item {
  background-color: rgba(0, 0, 0, 0.8) !important;
  border-radius: 0 !important;
  width: 100%;
  margin: 0 auto;
}

#second-menu-item:hover {
  background-color: rgba(0, 0, 0, 0.8) !important;
}

.el-tabs--border-card > .el-tabs__header .el-tabs__item {
  color: #000;
}
.el-container#main-container {
  flex-direction: column !important;
}
#custom-aside-menu.el-menu {
  border-right: none;

  background-color: #6b6b6b;
  height: 100%;
}
.el-menu-item {
  margin: 0.5rem auto;
}

.el-menu-item:focus {
  display: none !important;
}

.el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
  --tw-bg-opacity: 1;
  background-color: rgba(222, 164, 44, var(--tw-bg-opacity)) !important;
  color: #fff !important;
}

.el-tabs--border-card > .el-tabs__header .el-tabs__item:hover {
  --tw-bg-opacity: 1;
  background-color: rgba(222, 164, 44, var(--tw-bg-opacity)) !important;
  color: #fff !important;
}
.font-bold {
  font-weight: 400 !important;
}

.font-semi-bold {
  font-weight: 300 !important;
}
</style>
